module.exports = __webpack_public_path__ + "static/family-001ff1b8b3cf72441774f8633ab18db0.jpg";